<script lang="ts">
  import { getContext } from 'svelte'

  export let title: string
  export let description: string
  export let path = ''
  export let imagePath: string

  const deploymentUrl = getContext<string>('deploymentUrl')
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <meta name="og:url" content="{deploymentUrl}{path}" />
  <meta name="og:title" content={title} />
  <meta name="og:description" content={description} />
  <meta name="og:image" content="{deploymentUrl}{imagePath}" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content="{deploymentUrl}{imagePath}" />
</svelte:head>
